import { useState, useEffect } from 'react'

export const useIsIosDevice = () => {
  const [isIosDevice, setIsIosDevice] = useState(false)

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase()
    setIsIosDevice(/macintosh|mac os x|iphone|ipad|ipod/.test(userAgent))
  }, [])

  return isIosDevice
}
